import React from 'react';
import { ImagePlaceholder, Divider, Paragraph } from './Shared';
export function SectionIntro() {
  return <section data-id="element-94">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight text-left" data-id="element-95">
        Study Reveals: The Real Reason Behind Tooth Loss Has Nothing To Do With
        Hygiene (And Why 93% Of Adults Are Currently At Risk)
      </h1>

      <p className="text-xl md:text-2xl font-semibold text-gray-800 mb-8 text-left leading-snug" data-id="element-96">
        If you want to add years to the life of your teeth and prevent costly
        procedures without changing your routine, read this before you do
        anything else.
      </p>

      <img src="https://cdn.magicpatterns.com/uploads/cCbbg17X7VnC8ub5fJXUKV/Screenshot_2026-04-21_at_5.58.54_PM.png" alt="Dental science research and bacteria in micro-cracks" className="w-full rounded-lg my-8" data-id="element-97" />

      <div className="flex gap-4 my-6 py-4 pt-[0px] pb-[0px] items-center justify-start" data-id="element-98">
        <div className="w-14 h-14 rounded-full bg-gray-800 flex items-center justify-center text-white font-bold text-lg flex-shrink-0" data-id="element-99">
          AT
        </div>
        <p className="font-bold text-gray-900 flex items-center gap-2 text-[16px]" data-id="element-100">
          By Dr. Avedis Tevanian, DDS
          <svg className="w-5 h-5 text-blue-500 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-101">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" data-id="element-102" />
          </svg>
        </p>
      </div>

      <Paragraph data-id="element-103">
        In the next six minutes, you're going to LOSE ALL FEAR of tooth loss,
        dentures, and looking elderly before your time…
      </Paragraph>

      <Paragraph data-id="element-104">
        And instead, not only achieve the smile of your dreams, but quite
        literally 'turn back the clock' on the structural wear of your teeth.
      </Paragraph>

      <Paragraph data-id="element-105">
        All without stepping foot in a dentist's office and having to experience
        the fear of the "bill".
      </Paragraph>

      <Paragraph data-id="element-106">
        If you don't believe me, I will make it worth your while to change your
        mind…
      </Paragraph>

      <Paragraph data-id="element-107">
        While it may sound impossible, there has been a recent paradigm shift
        published in the Journal of Endodontics that is only just now hitting
        the highest levels of dental research…
      </Paragraph>

      <Paragraph data-id="element-108">
        And while it will likely take 10, 15, or even 20 years before this
        becomes 'standard protocol' in a neighborhood dentists office…
      </Paragraph>

      <Paragraph data-id="element-109">
        You, on the other hand, won't have to wait for your dentist to catch up.
      </Paragraph>

      <Paragraph data-id="element-110">
        In fact, in the next few minutes, you'll have the 'blueprints' to the
        structural and biological fortress you're about to build.
      </Paragraph>

      <Paragraph data-id="element-111">
        Because as it turns out, the real culprit has nothing to do with your
        hygiene, what you eat, or how often you visit the dentist…
      </Paragraph>

      <Paragraph data-id="element-112">
        Instead, it has to do with what dentists often dismiss as the dental
        equivalent of "wrinkles" on teeth, not knowing it's quietly keeping
        millions trapped in a cycle of frustration…
      </Paragraph>

      <Paragraph data-id="element-113">
        And according to Dr. Manjot Dhaliwal of Aster Dental Care, simply
        addressing it "not only adds years to the life of your teeth…
      </Paragraph>

      <Paragraph data-id="element-114">
        …but also prevents costly procedures down the road, making it a true
        investment in your dental health."
      </Paragraph>

      <Paragraph data-id="element-115">
        So if you're serious about finally putting an end to the cycle of
        frustration once and for all, turn off your notifications, take a seat,
        and make sure you read every word of this report.
      </Paragraph>

      <Divider data-id="element-116" />
    </section>;
}